import { render, staticRenderFns } from "./SignButtons.vue?vue&type=template&id=0a912cd8&scoped=true&"
import script from "./SignButtons.vue?vue&type=script&lang=js&"
export * from "./SignButtons.vue?vue&type=script&lang=js&"
import style0 from "./SignButtons.vue?vue&type=style&index=0&id=0a912cd8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a912cd8",
  null
  
)

export default component.exports